class LoadMore extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('load', () => {
      LoadMore.handlePageLoad()
    })
  }

  handleButtonClick(event) {
    event.preventDefault();
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    const searchParams = LoadMore.getSearchParams();
    const currentPage = LoadMore.getPageParams()
    LoadMore.renderPage(searchParams, currentPage);
    LoadMore.handleProductCount()
  }

  connectedCallback() {
    LoadMore.handleProductCount()

    this.querySelector('#load-more')?.addEventListener('click', this.handleButtonClick);
  }

  static handlePageLoad() {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentPage = currentSearchParams.get('page');
    const sections = LoadMore.getSections();

    // If current page is 1, only add page content to local storage
    if (!currentPage || currentPage == 1) {
      sections.forEach((section) => {
        LoadMore.fetchLocalStorageContent(section, 1)
      });
    } else {
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

      const currentPageNumber = Number(currentPage)
      const currentPageContent = document.getElementById('product-grid').innerHTML

      localStorage.setItem(`page-${currentPageNumber}`, currentPageContent);

      for (let pageNumber = 1; pageNumber <= currentPageNumber; pageNumber++) {
        // Check local storage for previous page content
        let pageContent = localStorage.getItem(`page-${pageNumber}`)

        // If content is not in local storage, fetch from URL and store in local storage
        if (!pageContent) {
          sections.forEach((section) => {
            pageContent = LoadMore.fetchLocalStorageContent(section, pageNumber, true)
          });
        }

        // If first page, replace grid content
        if (pageNumber === 1) {
          if (pageContent) {
            document.getElementById('product-grid').innerHTML = pageContent;
          }
        } else if (pageNumber === currentPageNumber) {
          document.getElementById('product-grid').innerHTML += currentPageContent
        } else {
          if (pageContent) {
            document.getElementById('product-grid').innerHTML += pageContent;
          }
        }
      }

      document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
    }
    LoadMore.handleProductCount()
  }

  static fetchLocalStorageContent(section, pageNumber, returnPageContent = false) {
    const currentSearchParams = new URLSearchParams(window.location.search);
    currentSearchParams.set('page', pageNumber);

    const searchParams = currentSearchParams.toString();
    const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

    fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      const gridContent = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
      localStorage.setItem(`page-${pageNumber}`, gridContent);

      if (returnPageContent) {
        return gridContent
      }
    });
  }

  static getPageParams() {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentPage = currentSearchParams.get('page');
    return currentPage;
  }

  static getSearchParams() {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentPage = currentSearchParams.get('page');
    const newPage = currentPage ? Number(currentPage) + 1 : 2;
    currentSearchParams.set('page', newPage);
    return currentSearchParams.toString();
  }

  static renderPage(searchParams, currentPage, updateURLHash = true) {
    LoadMore.searchParamsPrev = searchParams;
    const sections = LoadMore.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      LoadMore.renderSectionFromFetch(url, currentPage);
    });

    if (updateURLHash) LoadMore.updateURLHash(searchParams);
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  static renderSectionFromFetch(url, currentPage) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        LoadMore.cacheData = [...LoadMore.cacheData, { html, url }];
        LoadMore.renderProductGridContainer(html);
        const gridContent = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').innerHTML
        localStorage.setItem(`page-${currentPage}`, gridContent);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  /** Append product grid */
  static renderProductGridContainer(html) {
    document.getElementById('product-grid').innerHTML += new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid').innerHTML;

    document.getElementById('LoadMoreContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('LoadMoreContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }

  /** Display load previous button if client lands on any page after Page 1 */
  static handleLoadPrevious() {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const currentPage = currentSearchParams.get('page');
    const loadPrevious = document.getElementById('load-previous')

    if (!currentPage || !loadPrevious) {
      return
    }

    if (currentPage > 1) {
      loadPrevious.classList.remove('hidden');
      loadPrevious.setAttribute('aria-hidden', false)
    } else {
      loadPrevious.classList.add('hidden');
      loadPrevious.setAttribute('aria-hidden', true)
    }
  }

  static handleProductCount() {
    const productCards = document.getElementById('ProductGridContainer').querySelectorAll('.card');
    const loadMoreCount = document.getElementById('load-more-count');

    if (productCards && loadMoreCount) {
      const productCount = [...productCards].length
      loadMoreCount.innerHTML = productCount

      const loadMoreProgress = document.getElementById('load-more-progress')

      if (loadMoreProgress) {
        const pageTotal = Number(loadMoreProgress.dataset.pageTotal)
        const currentPage = Number(loadMoreProgress.dataset.currentPage)
        const progress = Math.floor((currentPage/pageTotal) * 100)

        document.getElementById('ProductGridContainer').style.setProperty('--load-more-progress', `${progress}%`);
      }

    }
  }
}

LoadMore.cacheData = [];
LoadMore.searchParamsInitial = window.location.search.slice(1);
LoadMore.searchParamsPrev = window.location.search.slice(1);

customElements.define('load-more', LoadMore);